<div id="jurisdiction-container">
  <div id="toggle-container" *ngIf="this.NODE != this.NODE_GLOBAL">
    <qr-toggle
      [config]="mainToggle"
      (change)="onChangeToggle($event)"
    ></qr-toggle>
  </div>
  <!-- Jurisdicciones -->
  <div id="table-header-container" *ngIf="this.mainToggle.optionSelected == 0">
    <app-table-header-new
      class="table-header"
      [tableHeader]="this.tableHeaderOrderByJurisdictions"
      [isCheckboxColumnVisible]="false"
      (orderByChange)="($event)"
    ></app-table-header-new>
    <div
      class="item-container"
      *ngFor="let row of this.jurisdictions; let i = index"
      [ngClass]="{ 'color-1': i % 2 == 0 }"
    >
      <p
        [id]="this.NODE != this.NODE_AR ? 'name-ec' : 'name'"
      >
        {{ row.name }}
      </p>
      <p
        [id]="this.NODE != this.NODE_AR ? 'p-ec' : 'iibb'"
      >
        {{ row.iibb }}%
      </p>
      <p
        id="cashflow"
        *ngIf="this.NODE == this.NODE_AR"
      >
        {{ row.previsionalCash }}%
      </p>
      <p
        *ngIf="this.NODE !== this.NODE_DO"
        [id]="this.NODE != this.NODE_AR ? 'p-ec' : 'alto'"
      >
        {{ row.altoDeductionPercentage }}%
      </p>
      <p
        *ngIf="this.NODE !== this.NODE_DO"
        [id]="this.NODE != this.NODE_AR ? 'p-ec' : 'puro'"
      >
        {{ row.puroDeductionPercentage }}%
      </p>
      <!-- DOMINICANA -->
      <p
        *ngIf="this.NODE === this.NODE_DO"
        class="p-do"
      >
        {{ row.deductionPercentage100 }}%
      </p>
      <p
        *ngIf="this.NODE === this.NODE_DO"
        class="p-do"
      >
        {{ row.deductionPercentage95 }}%
      </p>
      <p
        *ngIf="this.NODE === this.NODE_DO"
        class="p-do"
      >
        {{ row.deductionPercentage90 }}%
      </p>
      <!-- DOMINICANA -->
      <p
        [id]="this.NODE != this.NODE_AR ? 'p-ec' : 'team'"
      >
        {{ row.teamDeductionPercentage }}%
      </p>
      <div [id]="this.NODE != this.NODE_AR ? 'actions-ec' : 'actions'">
        <qr-button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          [config]="kebabButtonConfig"
          class="button-menu"
          matTooltip="Mas opciones"
        ></qr-button>
        <!-- Menu Options -->
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <div
              class="menu-billing"
              (click)="onActionButtonJurisdiction(row, 'edit')"
            >
              <qr-icon name="pencil" color="grey-600"></qr-icon>
              <p class="subheading-01-semi-bold">Modificar</p>
            </div>
          </button>
          <button
            mat-menu-item
            (click)="onActionButtonJurisdiction(row, 'delete')"
          >
            <div class="menu-billing">
              <qr-icon name="delete" color="grey-600"></qr-icon>
              <p class="subheading-01-semi-bold">Eliminar</p>
            </div>
          </button>
        </mat-menu>
        <!-- Menu Options -->
      </div>
    </div>
  </div>
  <!-- Jurisdicciones -->
  <!-- Compensaciones -->
  <div
    id="table-header-container-compensations"
    *ngIf="this.mainToggle.optionSelected == 1"
  >
    <app-table-header-new
      class="table-header"
      [tableHeader]="this.tableHeaderOrderByCompensations"
      [isCheckboxColumnVisible]="false"
      (orderByChange)="($event)"
    ></app-table-header-new>
    <div
      class="item-container"
      *ngFor="let row of this.compensations; let i = index"
      [ngClass]="{ 'color-1': i % 2 == 0 }"
    >
      <p >{{ row.name }}</p>
      <p >{{ row.billingPercentage }}%</p>
      <p  id="result">
        {{ row.grossPercentage }}%
      </p>
      <div id="actions">
        <qr-button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          [config]="kebabButtonConfig"
          class="button-menu"
          matTooltip="Mas opciones"
        ></qr-button>
        <!-- Menu Options -->
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <div class="menu-billing" (click)="onActionButton(row, 'edit')">
              <qr-icon name="pencil" color="grey-600"></qr-icon>
              <p class="subheading-01-semi-bold">Modificar</p>
            </div>
          </button>
          <button mat-menu-item (click)="onActionButton(row, 'delete')">
            <div class="menu-billing">
              <qr-icon name="delete" color="grey-600"></qr-icon>
              <p class="subheading-01-semi-bold">Eliminar</p>
            </div>
          </button>
        </mat-menu>
        <!-- Menu Options -->
      </div>
    </div>
    <!-- Compensaciones -->
  </div>
</div>
